import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import vuetify from "./plugins/vuetify";
import axios from "axios";
import "vuetify/dist/vuetify.css";


Vue.config.productionTip = false;
new Vue({
  router,
  vuetify,
  axios,
  render: (h) => h(App),
}).$mount("#app");
